import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

export const LanguageToggle = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="relative h-[42px] p-1 rounded-full border border-white/5 bg-[#121822] w-[108px]">
      <div className="relative w-full h-full">
        {/* Active Pill Background */}
        <div 
          className="absolute inset-y-0 left-0 w-1/2 rounded-full bg-brand-teal/20 transition-transform duration-300 ease-out"
          style={{ transform: language === 'pt' ? 'translateX(0%)' : 'translateX(100%)' }}
        />
        
        {/* Buttons */}
        <button 
          onClick={() => changeLanguage('pt')}
          className={`absolute inset-y-0 left-0 w-1/2 flex justify-center items-center px-0 py-0 m-0 border-0 outline-none appearance-none bg-transparent text-[14px] font-bold tracking-normal transition-colors cursor-pointer ${
            language === 'pt' ? 'text-brand-teal' : 'text-white/40 hover:text-white/70'
          }`}
          aria-label="Português"
        >PT</button>
        <button 
          onClick={() => changeLanguage('en')}
          className={`absolute inset-y-0 right-0 w-1/2 flex justify-center items-center px-0 py-0 m-0 border-0 outline-none appearance-none bg-transparent text-[14px] font-bold tracking-normal transition-colors cursor-pointer ${
            language === 'en' ? 'text-brand-teal' : 'text-white/40 hover:text-white/70'
          }`}
          aria-label="English"
        >EN</button>
      </div>
    </div>
  );
};

